import clsx from "clsx";
import classes from "./List.module.css";

import ListItem from "../ListItem/ListItem";
import ImageModal from "../ImageModal/ImageModal";

interface ListInterface {
  list: any;
  noVideo: boolean;
  onParagraphClick: any;
  url: string;
}

const List = ({ list, noVideo, onParagraphClick, url }: ListInterface) => {
  const oneVideo = list.url !== "";
  const lis = list.children.map((li: any) => {
    if (li.type === "li") {
      return (
        <ListItem
          li={li}
          oneVideo={oneVideo}
          url={url}
          onParagraphClick={onParagraphClick}
          noVideo={noVideo}
        />
      );
    } else if (li.type === "list") {
      return (
        <li style={{ listStyle: li?.nomarker ? "none" : undefined }}>
          <List
            list={li}
            noVideo={noVideo}
            onParagraphClick={onParagraphClick}
            url={url}
          />
        </li>
      );
    } else if (li.type === "image") {
      return (
        <ImageModal
          path={li.path}
          alt={li.alt}
          url={li.url}
          currentUrl={url}
          width={li?.width}
          onParagraphClick={onParagraphClick}
        />
      );
    } else return <></>;
  });

  if (list.ordered)
    return (
      <ol
        className={clsx(oneVideo && !noVideo && classes.clickable)}
        onClick={() => oneVideo && !noVideo && onParagraphClick(list.url)}
        style={{
          backgroundColor: list.url === url ? "white" : undefined,
          listStyle: list?.liststyle ? list.liststyle : undefined,
        }}
        key={list.url}
        start={list?.start}
      >
        {lis}
      </ol>
    );

  return (
    <ul
      className={clsx(oneVideo && !noVideo && classes.clickable)}
      onClick={() => oneVideo && !noVideo && onParagraphClick(list.url)}
      style={{
        backgroundColor: list.url === url ? "white" : undefined,
        listStyle: list?.liststyle ? list.liststyle : undefined,
      }}
      key={list.url}
    >
      {lis}
    </ul>
  );
};

export default List;
